// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1MW7s","option":"styles_option__3uVc3","active":"styles_active__32o1m"};